// extracted by mini-css-extract-plugin
module.exports = {"paymentDetails":"InteractApplicationConfirmation_paymentDetails__XWZtp","interact-confirmation":"InteractApplicationConfirmation_interact-confirmation__ThSim"};